package music.jammers.client.shared.event.track.domain.usecase

import music.jammers.client.shared.event.track.domain.repository.EventTrackRepository
import music.jammers.shared.event.track.domain.model.EventTrack
import music.jammers.shared.event.track.domain.model.UpdateEventTrack

class UpdateEventTrackUseCase(
    private val eventTrackRepository: EventTrackRepository,
) {

    suspend operator fun invoke(
        eventTrackId: Long,
        updateEventTrack: UpdateEventTrack,
    ): EventTrack =
        eventTrackRepository.update(eventTrackId, updateEventTrack)
}